import { render, staticRenderFns } from "./regionDataList.vue?vue&type=template&id=39d92dde&scoped=true"
import script from "./regionDataList.vue?vue&type=script&lang=js"
export * from "./regionDataList.vue?vue&type=script&lang=js"
import style0 from "./regionDataList.vue?vue&type=style&index=0&id=39d92dde&prod&lang=scss&scoped=true"
import style1 from "./regionDataList.vue?vue&type=style&index=1&id=39d92dde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d92dde",
  null
  
)

export default component.exports